import React from 'react';
import clsx from 'clsx';

export function Badge({
	color = 'grey',
	emphasized = true,
	className,
	children,
	...rest
}: {
	color?: 'grey' | 'blue' | 'green' | 'yellow' | 'alarm' | 'ai';
	emphasized?: boolean;
	className?: string;
	children: React.ReactNode;
}) {
	return (
		<div
			className={clsx(
				'inline-block w-fit rounded-[4px] px-2 py-1 text-xs',
				[
					emphasized && 'font-semibold',
					color === 'alarm' && 'bg-cherry-50 text-cherry-500',
					color === 'grey' && 'bg-grey-70 text-text-primary',
					color === 'blue' && 'bg-[#E1DCF9] text-purple-500',
					color === 'green' && 'bg-green-100 text-green-800',
					color === 'yellow' && 'bg-yellow-100 text-yellow-700',
					color === 'ai' && 'bg-linear-(--gradient-ai-icon-no-text) text-white',
				],
				className,
			)}
			{...rest}
		>
			{children}
		</div>
	);
}
